import React from "react";
import CustomerPage from "./tenant components/CustomerDetails";
import {useLocation} from "react-router-dom";
import {Alert, Box, Typography, Chip, Divider, useTheme, useMediaQuery} from "@mui/material";
import {
    WarningAmberOutlined,
    EventNoteOutlined,
    HomeOutlined,
    AccountBalanceWalletOutlined
} from "@mui/icons-material";

export default function TenantV2(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let {state} = useLocation();
    let {tenant_id, property_id, isVacated, vacatingDetails} = state || {};

    return (
        <div>
            {isVacated && (
                <Box sx={{
                    mb: isMobile ? 2 : 3,
                    mx: isMobile ? 1 : 0,
                }}>
                    <Alert
                        severity="warning"
                        icon={<WarningAmberOutlined sx={{fontSize: isMobile ? 24 : 28}}/>}
                        sx={{
                            border: '2px solid #ff9800',
                            borderRadius: isMobile ? '8px' : '12px',
                            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)',
                            backgroundColor: '#fff8e1',
                            padding: isMobile ? '12px' : '16px',
                            '& .MuiAlert-message': {
                                width: '100%'
                            },
                            '& .MuiAlert-icon': {
                                padding: isMobile ? '4px 0' : '7px 0',
                            }
                        }}
                    >
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: isMobile ? 1.5 : 2}}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                flexWrap: 'wrap',
                            }}>
                                <Typography
                                    variant={isMobile ? "subtitle1" : "h6"}
                                    sx={{
                                        fontWeight: 600,
                                        color: '#e65100',
                                        fontSize: isMobile ? '0.95rem' : '1.25rem',
                                    }}
                                >
                                    VACATED TENANT
                                </Typography>
                                <Chip
                                    label="Inactive"
                                    size="small"
                                    sx={{
                                        backgroundColor: '#ff9800',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: isMobile ? '0.7rem' : '0.75rem',
                                    }}
                                />
                            </Box>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#5d4037',
                                    fontSize: isMobile ? '0.8rem' : '1rem',
                                }}
                            >
                                This tenant has submitted a vacating notice and is no longer actively occupying the unit.
                            </Typography>

                            {vacatingDetails && (
                                <>
                                    <Divider sx={{borderColor: '#ffb74d'}}/>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: isMobile ? 'column' : 'row',
                                        flexWrap: 'wrap',
                                        gap: isMobile ? 1.5 : 3,
                                    }}>
                                        {vacatingDetails.date_to_vacate && (
                                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                <EventNoteOutlined sx={{color: '#f57c00', fontSize: isMobile ? 18 : 20}}/>
                                                <Typography variant="body2" sx={{fontWeight: 500, fontSize: isMobile ? '0.75rem' : '0.875rem'}}>
                                                    Vacated: <strong>{vacatingDetails.date_to_vacate}</strong>
                                                </Typography>
                                            </Box>
                                        )}

                                        {vacatingDetails.deposit_held && (
                                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                <AccountBalanceWalletOutlined sx={{color: '#f57c00', fontSize: isMobile ? 18 : 20}}/>
                                                <Typography variant="body2" sx={{fontWeight: 500, fontSize: isMobile ? '0.75rem' : '0.875rem'}}>
                                                    Deposit Held: <strong>
                                                        {parseFloat(vacatingDetails.deposit_held.toString().replace(/,/g, '')).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "KSH",
                                                        })}
                                                    </strong>
                                                </Typography>
                                            </Box>
                                        )}

                                        {vacatingDetails.deposit_to_refund && vacatingDetails.deposit_to_refund !== "" && (
                                            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                <AccountBalanceWalletOutlined sx={{color: '#4caf50', fontSize: isMobile ? 18 : 20}}/>
                                                <Typography variant="body2" sx={{fontWeight: 500, fontSize: isMobile ? '0.75rem' : '0.875rem'}}>
                                                    Refundable: <strong style={{color: '#4caf50'}}>
                                                        {parseFloat(vacatingDetails.deposit_to_refund.toString().replace(/,/g, '')).toLocaleString("en-US", {
                                                            style: "currency",
                                                            currency: "KSH",
                                                        })}
                                                    </strong>
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Alert>
                </Box>
            )}
            <CustomerPage tenant_id={tenant_id} property_id={property_id} isVacated={isVacated} vacatingDetails={vacatingDetails}/>
        </div>
    );
}
